import React from 'react';
import NavigationHandler from './core/routes';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from './store/reducer-main';
import { onAuthStateChanged } from './service/common/firebase';
import { loadProfile } from './store/profile/slice';
import { loadStripeInstance, loadStripeProducts } from './store/stripe/slice';
import LoadingPage from './core/routes/common/LoadingPage';
import { loadStripe } from '@stripe/stripe-js';

export default function Startup() {

  const dispatch = useDispatch();
  const { checked, loadingProfile } = useSelector((state: StoreState) => state.profile);

  const appIsReady = React.useMemo(() => {
    return checked;
  }, [checked]);

  React.useEffect(() => {
    loadIndipendentData();
    const unsubscribe = onAuthStateChanged((userAuthInfo) => {
      if (userAuthInfo) {
        dispatch(loadProfile(userAuthInfo));
      } else {
        dispatch(loadProfile(null));
      }
    });

    return () => {
      unsubscribe();
    }
  }, []);

  const loadIndipendentData = async() => {
    dispatch(loadStripeProducts());
    const stripe = await loadStripe(process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY as string);
    dispatch(loadStripeInstance(stripe));
  }

  return (
    <React.Fragment>
      {
        appIsReady
          ? <NavigationHandler />
          : <LoadingPage />
      }
    </React.Fragment>
  )
}